// One look for every text input, select and textarea in the panel.
export const fieldClass =
  'w-full min-h-[44px] rounded-[12px] border border-line-strong bg-surface px-3.5 py-2 text-sm text-ink outline-none transition ' +
  // Design `.inp:focus`: a 2px accent outline 1px outside the unchanged border.
  'placeholder:text-muted focus:outline-2 focus:outline-offset-1 focus:outline-accent focus:ring-0 disabled:cursor-not-allowed disabled:bg-surface-2';

// Names longer than this break card layouts and nobody needs them.
export const NAME_MAX = 120;
